import Game from './lib/game.js';
import Dog from './lib/dog.js';
import MovingObject from './lib/moving_objects.js';
import Board from './lib/board.js';
import Path from './lib/path.js';
import Bomb from './lib/bomb.js';


export const canvas = document.getElementById("canvas");
export const ctx = canvas.getContext("2d");

const menuDog = new Image();
menuDog.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/c_scale,q_10,w_100/v1518548399/dog_jv6crw.gif';
const menuBackground = new Image();
menuBackground.src = 'https://res.cloudinary.com/dhjxj05jc/image/upload/v1518715971/menubackground_rwr1my.jpg'

  // const game = new Game(ctx);
  let dog = new Dog;

  let dog2 = new Dog;

  let dog3 = new Dog;

  let cars = [new MovingObject(100, 425, 85, 75), new MovingObject(300, 425, 85,75),
    new MovingObject(400, 550, 85, 75), new MovingObject(10, 550, 85, 75) ];
  let board = new Board;

  let mower = new MovingObject(700, 321, 100, 80);

  let workers = [new MovingObject(200, 100, 80, 80), new MovingObject(500, 100, 80, 80),
  new MovingObject(50, 80, 80, 80), new MovingObject(120, 80, 80, 80)];

  let dozer = new MovingObject (500, 48, 280, 275);

  let paths = [new Path(300,620,100,100), new Path(300,520,100,100),
  new Path(300,420,100,100), new Path(300,320,100,100),
  new Path(300,220,100,100), new Path(300,120,100,100),
  new Path(300,20,100,100)];

  let fireballs = [ new MovingObject(100, 425, 85, 75), new MovingObject(185, 425, 85, 75),
  new MovingObject(270, 425, 85, 75), new MovingObject(355, 425, 85, 75), new MovingObject(440, 425, 85, 75),
  new MovingObject(525, 425, 85, 75), new MovingObject(610, 425, 85, 75)

,new MovingObject(58, 500, 85, 75), new MovingObject(185, 500, 85, 75),
new MovingObject(270, 500, 85, 75), new MovingObject(355, 500, 85, 75), new MovingObject(440, 500, 85, 75),
new MovingObject(525, 500, 85, 75), new MovingObject(610, 500, 85, 75), new MovingObject(695, 500, 85, 75)];

  let tennisBoy = new MovingObject(700, 0, 115, 115);

  let cat = new MovingObject(665, 175, 100, 80);
  let cat2 = new MovingObject(665, 65, 100, 80);

  let catBoss = new MovingObject(200, -25, 350, 350);
  let furBomb1 = new Bomb();
  let furBomb2 = new Bomb();
  let furBomb3 = new Bomb();
  let furBomb4 = new Bomb();
  let furBomb5 = new Bomb();
  let furBomb6 = new Bomb();
  let furBomb7 = new Bomb();
  let furBomb8 = new Bomb();
  let furBomb9 = new Bomb();
  let furBomb10 = new Bomb();
  let furBomb11 = new Bomb();

  let explosion = new Board;

  function onPath(path) {
    if ((dog2.dogY < path.pathY + 100 && dog2.dogY > path.pathY) &&
    !((dog2.dogX > paths[0].pathX - 40) && dog2.dogX < path.pathX + 70)) {
      dog2.dogY = (canvas.height - dog.height - 10);
      dog2.dogX = (canvas.width - dog.width) / 2;
      lives -= 1;
      document.getElementById('death').play();
      cat = new MovingObject(665, 175, 100, 80);
      cat2 = new MovingObject(665, 65, 100, 80);

    }
  }


  window.addEventListener("keydown", keyPressed, false);
  window.addEventListener("keyup", keyReleased, false);

  let leftPressed = false;
  let rightPressed = false;
  let upPressed = false;
  let downPressed = false;
  let spacePressed = false;
  let lives = 5;
  let level = 0;

  function drawBorder () {
    ctx.rect(20,20,700,700);
    ctx.stroke();
  }


  function keyPressed(e) {
    e.preventDefault();
    switch(e.keyCode) {
      case 37:
        leftPressed = true;
        break;
      case 38:
        upPressed = true;
        break;
      case 39:
        rightPressed = true;
        break;
      case 40:
        downPressed = true;
        break;
      case 32:
        spacePressed = true;
        break;
    }
  }

  function keyReleased(e) {
    switch(e.keyCode) {
      case 37:
        leftPressed = false;
        break;
      case 38:
        upPressed = false;
        break;
      case 39:
        rightPressed = false;
        break;
      case 40:
        downPressed = false;
        break;
      case 32:
        spacePressed = false;
        break;
    }
  }


  function drawLives() {
    if (level === 1) {
      ctx.fillStyle = 'red';
    } else if (level === 2) {
      ctx.fillStyle = 'lightblue';
    }
    else {
      ctx.fillStyle = 'white';
    }
    ctx.font="30px Arial";
    ctx.fillText(`Lives: ${lives}`, 25, 50);
  }


  function collision(currDog, movingObject) {
    if (movingObject.movingObjectX <= currDog.dogX + currDog.width - 35 &&
    movingObject.movingObjectX + movingObject.movingObjectWidth >= currDog.dogX + 35 &&
    movingObject.movingObjectY + movingObject.movingObjectHeight >= currDog.dogY + 22 &&
    movingObject.movingObjectY <= currDog.dogY + currDog.height - 22) {
      currDog.dogY = (canvas.height - currDog.height - 10);
      currDog.dogX = (canvas.width - currDog.width) / 2;
      lives -= 1;
      document.getElementById('death').play();
      mower = new MovingObject(700, 321, 100, 80);
      cat = new MovingObject(665, 175, 100, 80);
      cat2 = new MovingObject(665, 65, 100, 80);
    }
    if (lives === 0) {
      clearInterval(gameLoop);
      if (lives === 0) {
        if (level === 2) {
          ctx.fillStyle = 'lightblue';
          ctx.fillText('GAME OVER', canvas.width/2 - 70, canvas.height/2 - 70);
        } else if (level === 1) {
          ctx.fillStyle = 'red';
          ctx.fillText('GAME OVER', canvas.width/2 - 70, canvas.height/2 - 70);
        }
        else {
          ctx.fillStyle = 'white';
          ctx.fillText('GAME OVER', canvas.width/2 - 70, canvas.height/2 - 70);
        }
      }
    }
  }

  function bombCollision(currDog, bomb) {
    if (bomb.bombX <= currDog.dogX + currDog.width - 35 &&
    bomb.bombX + bomb.bombWidth >= currDog.dogX + 35 &&
    bomb.bombY + bomb.bombHeight >= currDog.dogY + 22 &&
    bomb.bombY <= currDog.dogY + currDog.height - 22) {
      currDog.dogY = (canvas.height - currDog.height - 10);
      currDog.dogX = (canvas.width - currDog.width) / 2;
      lives -= 1;
      document.getElementById('death').play();
    }
    if (lives === 0) {
      clearInterval(gameLoop);
    }
  }

  function catBossCollision(currDog, movingObject) {
    if (movingObject.movingObjectX <= currDog.dogX + currDog.width - 100 &&
    movingObject.movingObjectX + movingObject.movingObjectWidth >= currDog.dogX + 100 &&
    movingObject.movingObjectY + movingObject.movingObjectHeight >= currDog.dogY + 75 &&
    movingObject.movingObjectY <= currDog.dogY + currDog.height - 22) {
      currDog.dogY = (canvas.height - currDog.height - 10);
      currDog.dogX = (canvas.width - currDog.width) / 2;
      lives -= 1;
      document.getElementById('death').play();
    }
    if (lives === 0) {
      ctx.fillStyle = 'white';
      ctx.fillText('GAME OVER', canvas.width/2 - 70, canvas.height/2);
      clearInterval(gameLoop);
    }
  }

  function mustBait(currDog, bait, x, y) {
    if (currDog.dogY > x && currDog.dogY < y) {
      bait.movingObjectX -= 30;
    }
  }

  let frameCount = 0;
  function levelOneDraw() {
    level = 1;
    frameCount++;
    board.drawRoad();
    board.drawSite();
    board.drawGrass();
    dog.drawDog(rightPressed, leftPressed, downPressed, upPressed);
    mower.drawMower();
    dozer.drawDozer();
    for (var j = 0; j < cars.length; j++) {
      cars[j].drawCars();
    }
    for (var k = 0; k < workers.length; k++) {
      workers[k].drawWorkers();
    }
    for (var i = 0; i < cars.length; i++) {
      collision(dog, cars[i]);
    }

    collision(dog, dozer);
    collision(dog, mower);
    mustBait(dog, mower, 370, 420);
    for (var l = 0; l < workers.length; l++) {
      collision(dog, workers[l]);
      if (dog.dogY === 29) {
        level = 2;
      }
    }

  }

  function levelTwoDraw() {
    board.drawLava();
    for (var i = 0; i < paths.length; i++) {
      paths[i].drawPath();
    }
    for (var j = 0; j < paths.length; j++) {
      onPath(paths[j]);
    }
    dog2.drawDog(rightPressed, leftPressed, downPressed, upPressed);
    tennisBoy.drawTennisBoy();
    collision(dog2, tennisBoy);
    cat.drawCat();
    cat2.drawCat();
    collision(dog2, cat2);
    mustBait(dog2, cat2, 90, 140);
    collision(dog2, cat);
    mustBait(dog2, cat, 200, 250);
    for (var j = 0; j < fireballs.length; j++) {
      fireballs[j].drawFireballs();
    }
    for (var k = 0; k < fireballs.length; k++) {
      collision(dog2, fireballs[k]);
    }
    if (dog2.dogY === 29) {
      level = 3;
    }
  }

  let bossTime = 0;
  let timeLeft = 10;

  function levelThreeDraw() {
    board.drawPurp();
    ctx.fillStyle = 'white';
    if (bossTime < 800 && lives !== 1) {
      ctx.fillText('STAY ALIVE!', canvas.width/2 - 70, canvas.height/2);
    }
    dog3.drawDog(rightPressed, leftPressed, downPressed, upPressed);
    furBomb1.drawfurBomb();
    bombCollision(dog3, furBomb1);
    setTimeout(() => furBomb2.drawfurBomb(), 1000);
    bombCollision(dog3, furBomb2);
    setTimeout(() => furBomb3.drawfurBomb(), 2000);
    bombCollision(dog3, furBomb3);
    setTimeout(() => furBomb4.drawfurBomb(), 3000);
    bombCollision(dog3, furBomb4);
    setTimeout(() => furBomb5.drawfurBomb(), 4000);
    bombCollision(dog3, furBomb5);
    setTimeout(() => furBomb6.drawfurBomb(), 5000);
    bombCollision(dog3, furBomb6);
    setTimeout(() => furBomb7.drawfurBomb(), 6000);
    bombCollision(dog3, furBomb7);
    setTimeout(() => furBomb8.drawfurBomb(), 7000);
    bombCollision(dog3, furBomb8);
    setTimeout(() => furBomb9.drawfurBomb(), 8000);
    bombCollision(dog3, furBomb9);
    setTimeout(() => furBomb10.drawfurBomb(), 9000);
    bombCollision(dog3, furBomb10);
    setTimeout(() => furBomb11.drawfurBomb(), 10000);
    bombCollision(dog3, furBomb11);
    catBoss.drawCatBoss();
    catBossCollision(dog3, catBoss);
    let timer = timeLeft - Math.round(bossTime/100);
    ctx.fillStyle = 'white';
    ctx.fillText(`${timer} seconds left`, 505, 55);

    bossTime ++;
    if (bossTime === 1000 ) {
      ctx.fillStyle = 'white';
      explosion.drawExplosion();
      clearInterval(gameLoop);
      ctx.font="30px Arial";
      ctx.fillText('YOU WIN!', canvas.width/2 - 50, canvas.height/2);
    }
  }



  function drawMenu () {
    if (spacePressed === true) {
      level = 1;
    }

    ctx.drawImage(menuBackground, 21,21,698,698);

    ctx.font="30px Arial";
    ctx.fillText("PRESS SPACE BAR TO BEGIN", (canvas.width/2 - 200), 100);
    ctx.fillText("Every Dog", (canvas.width/2 - 50), 240);
    ctx.drawImage(menuDog, 345 , 250, 75, 75);
    ctx.fillText("Has it's Day", (canvas.width/2 - 55), canvas.height/2);
  }


  function draw() {
    ctx.clearRect(0,0,canvas.width,canvas.height);
    drawBorder();
    if (level === 1) {
      levelOneDraw();
      drawLives();
    } else if (level === 2) {
      levelTwoDraw();
      drawLives();
    } else if (level === 3) {
      levelThreeDraw();
      drawLives();
    } else if (level === 0) {
      drawMenu();
    }
  }



  const gameLoop = window.setInterval(draw, 10);



// WEBPACK FOOTER //
// ./dogger.js